<template>
  <div class="lms-spotwind position-relative">
    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>
    <div class="position-absolute" style="right: 20px; top: 15px; z-index: 100" v-if="isLoading"><img :alt="$t('loading')" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="isDataLoaded">

      <form action="?">
        <label class="w100 fl tr" for="selectDate">{{ $t('lms.select_time') }}:</label>

        <select class="w150 fl mr-1" id="selectDate" v-model="selectedDate">
          <option v-for="date in listOfDates" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }}</option>
        </select>
        <span class="lh-form mr-3 fl">UTC</span>

        <button type="button" :title="$t('prev')"  class="button button-icon-only fl w50" @click="nextIndex()" :disabled="nextDisabled"><i class="icon-navigate_before"></i></button>
        <button type="button" :title="$t('next')"  class="button button-icon-only fl w50" @click="prevIndex()" :disabled="prevDisabled"><i class="icon-navigate_next"></i></button>

        <button type="button" @click="getData()" :title="$t('refresh_txt')" class="button ml-2 fl w75">{{ $t('lms.refresh') }}</button>
        <div class="clearfix"></div>
      </form>

      <template v-if="selectedImage">

        <div class="images-wrapper">
          <a :href="selectedPdf" target="_blank">
          <img :src="selectedImage" />
          </a>
        </div>


      </template>

    </div>


  </div>
</template>

<script>

import SHMUconf from '../../shmu_conf';
import Axios from "axios";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  components: {
    CoolLightBox
  },
  name: 'LmsSigmetComponent',
  props: {
    msg: String
  },
  data() {
    return {
      latestData: [],
      listOfDates: [],
      listOfForecasts: [],
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isLoading: false,
      selectedDate: null,
      iIndex: null,
      prevDisabled: false,
      nextDisabled: false,
    }
  },
  watch: {
    selectedDate(v) {

      let currentIndex = this.listOfDates.findIndex(item => item === v);
      let minIndex = 0;
      let maxIndex = this.listOfDates.length - 1;

      if (currentIndex <= minIndex) {
        this.prevDisabled = true;
      } else {
        this.prevDisabled = false;
      }

      if (currentIndex >= maxIndex) {
        this.nextDisabled = true;
      } else {
        this.nextDisabled = false;
      }

    }
  },
  mounted() {
    this.getData();

  },
  computed: {
    selectedDateIndex() {
      const sDate = this.selectedDate;
      return this.listOfDates.findIndex(item => item === sDate);

    },
    selectedImage() {
      const sDate = this.selectedDate;
      if (sDate) {
        let r = this.latestData.find(item => item.dt === sDate);
        if (r) {
          return SHMUconf.SITE_BASE_URL + 'data/' + r.file_link_jpeg;
        }
      }
    },
    selectedPdf() {
      const sDate = this.selectedDate;
      if (sDate) {
        let r = this.latestData.find(item => item.dt === sDate);
        if (r) {
          return SHMUconf.SITE_BASE_URL + 'data/' + r.file_link_pdf;
        }
      }
    },



  },
  methods: {
    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'lms/getsurfana', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.latestData = response.data.data;
          self.listOfDates =  self.latestData.map((item) => item.dt).sort().reverse();

          if (self.listOfDates.length) {
            self.selectedDate = self.listOfDates[0];
          }

          self.isDataLoaded = true;
          this.isError = false;
          this.errorMsg = null;

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });

    },

    setIndex(index) {
      this.iIndex = index
    },

    prevIndex() {
      if (this.selectedDateIndex > 0) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex - 1];
      }
    },
    nextIndex() {
      if (this.selectedDateIndex < this.listOfDates.length - 1) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex + 1];
      }
    },


  }
}
</script>

<style scoped lang="scss">
.images-wrapper {
  img {
    width: 100%;
    max-height: 100%;

    &.hidden {
      display: none;
    }


    &:hover {
      cursor: zoom-in;
    }
  }
}

button:disabled,
button[disabled]{
  border: 1px solid #ccc;
  background-color: #f8f7f7 !important;
  background-image: unset;
  color: #b3b1b1;
}



</style>
